import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const fmtYear = (iso) => new Date(iso).getFullYear();

/** Tailwind class fragment for an inquiry status pill. */
export const inquiryStatusClass = (status) => {
  if (status === "paid") return "bg-[#ac62ea]/10 text-[#ac62ea] border-[#ac62ea]/30";
  if (status === "quoted") return "bg-[#0047FF]/10 text-[#0047FF] border-[#0047FF]/30";
  return "bg-[#F5A623]/10 text-[#F5A623] border-[#F5A623]/30";
};
